import { BaseModel } from "../../Bases/BaseModel";

export class UsuarioFiltroAcesso extends BaseModel {
  constructor(
    public origem_id = 0,
    public transportador_id = 0,
    public destino_id = 0,
    public valor_minimo = '',
    public valor_maximo = '',
    public origem_nome = '',
    public transportador_nome = '',
    public destino_nome = ''
  ) {
    super();
  }
}



